import { createBrowserHistory } from 'history';
import * as dotenv from 'dotenv';
dotenv.config();

export default createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});
